/**
 * @file: 整理层板数据顺序，按posY降序排列
 * @author: xiaolong.huang@dmall.com
 */

import * as StageStatus from '../stageStatus';
import Utils from '../utils/util';
import Config from '../config/index';

let posYKey: string = Config.get({
    moduleName: 'layer',
    key: 'keyMap.posY'
});

export default function layerSort(shelfData: JsonData): void {
    // 卧柜只有1个层板，不需要排序
    if (StageStatus.isTopFace()) {
        return;
    }
    
    let insertIndex: number = 0;

    for(let i: number = 0; i < shelfData.cubes.length; i++) {
        let cubeData: FreeObjMap = shelfData.cubes[i];

        if (cubeData.moduleName !== 'shelves') {
            continue;
        }

        let layers: Array<FreeObjMap> = cubeData.cubes || [];

        cubeData.cubes = Utils.quickSortByKey(layers, posYKey).reverse();
    }
}
